import { useReactiveVar } from '@apollo/client';

import { CommsAgencyChat } from '@/features/comms/screens/CommsAgencyChat';
import { SupabaseProvider } from '@/features/comms/supabase/SupabaseProvider';
import { currentAdminVar } from '@/util/apollo/cache';

/**
 * Standalone "Chat V2" ops page (comms canary).
 *
 * Renders the existing `CommsAgencyChat` surface UNCONDITIONALLY. There is no
 * global backend swap — the main inbox is always PubNub, and this dedicated
 * page is the only way an operator reaches Supabase chat.
 *
 * This is the only place a `SupabaseProvider` is mounted with `forceEnabled`,
 * so this route is the only surface with a live Supabase client.
 */
const ChatV2 = () => {
  const currentAdmin = useReactiveVar(currentAdminVar);

  return (
    <SupabaseProvider
      forceEnabled
      isAuthenticated={!!currentAdmin}
      userId={currentAdmin?.user?.id}
    >
      <CommsAgencyChat />
    </SupabaseProvider>
  );
};

export default ChatV2;
